export default "__VITE_ASSET__DyEU8nmA__"